var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import MedicalPrescriptionsCardAPI from './medical-prescriptions-card-api';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './medical-prescriptions-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let MedicalPrescriptionsCard = class MedicalPrescriptionsCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { data, nmMdPrescr, ieStatus, nrPrescription, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        data,
                        ieStatus,
                        nmMdPrescr,
                        nrPrescription,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIndicatorColorStatus() {
        const { ieStatus } = this.props;
        if (ieStatus) {
            if (ieStatus.toUpperCase() === 'A') {
                return React.createElement("div", { className: 'c-clinical-notes-card__indicator-color-green' });
            }
            return React.createElement("div", { className: 'c-clinical-notes-card__indicator-color-orange' });
        }
        return React.createElement("div", { className: 'c-clinical-notes-card__indicator-color-gray' });
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-clinical-notes-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    renderField() {
        const { data, nmMdPrescr, nrPrescription } = this.props;
        const message = MessageService.translate('tws.pending-exam-collection.prescription-number');
        const title = message.replace('#@NR_PRESCRICAO#@', String(nrPrescription));
        let date = '';
        let hours = '';
        if (data) {
            const [d, h] = data.split('-');
            date = d;
            hours = h;
        }
        return (React.createElement("div", { className: 'c-medical-precriptions-card__avatar' },
            React.createElement("div", { className: 'c-medical-precriptions-card__image' },
                React.createElement(Avatar, null)),
            React.createElement("div", { className: 'c-medical-precriptions-card__wrapper-left' },
                React.createElement("h5", null, title),
                React.createElement("span", null, nmMdPrescr)),
            React.createElement("div", { className: 'c-medical-precriptions-card__wrapper-right' },
                React.createElement("h5", null, hours),
                React.createElement("span", null, date))));
    }
    render() {
        const { ieStatus, nmMdPrescr } = this.props;
        return (React.createElement(Card, { className: 'c-medical-precriptions-card', onClick: () => this.onClick(), selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: `${ieStatus} + ${nmMdPrescr}`, width: 12 },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-medical-precriptions-card__wrapper' }, this.renderField())));
    }
};
MedicalPrescriptionsCard = __decorate([
    AwesomeComponent({ api: MedicalPrescriptionsCardAPI, type: ComponentType.DATA_DISPLAY })
], MedicalPrescriptionsCard);
export default MedicalPrescriptionsCard;
//# sourceMappingURL=medical-prescriptions-card.js.map